module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-7"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "head"
  }, [_vm._v("Scenes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter1#Part1"
    }
  }, [_vm._v("ACT ONE")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter1#ch1"
    }
  }, [_vm._v("Scene One. The living room of the Callifers’ house, Wild Grove, in what was once the country. An autumn afternoon.")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene Two. The same. Evening, two days later.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter3#Part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACT TWO")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene One. James Callifer’s lodgings in Nottingham. Four weeks later.")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene Two. Father William Callifer’s presbytery, somewhere in East Anglia. Evening, the next day.")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter5#Part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACT THREE")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The living room at Wild Grove. The next evening.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0